<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
         x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve"
         :width="size ? size : 512" :height="size ? size : 512"
         :class="[color]">
        <g>
            <path xmlns="http://www.w3.org/2000/svg" d="m12 1a11 11 0 1 0 11 11 11.013 11.013 0 0 0 -11-11zm0 20a9 9 0 1 1 9-9 9.011 9.011 0 0 1 -9 9z" class="a"></path>
            <path xmlns="http://www.w3.org/2000/svg" d="m13 11.586v-5.586a1 1 0 0 0 -2 0v6a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414z" class="a"></path>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconClock",
    props: ['color', 'size'],

    computed: {
        css(){
            return {fill: this.fill};
        }
    }

}
</script>
<style lang="scss" scoped>
.a{fill:white}

.dark{
    .a{
        fill:#4a4a5a;
    }
}
</style>
